/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AwsSsmDocumentTag {
    getFixupPrototypeFunction() { return AwsSsmDocumentTag.fixupPrototype; }

    static newInstance(model: Partial<AwsSsmDocumentTag>): AwsSsmDocumentTag {
        let obj = Object.assign(new AwsSsmDocumentTag(), model);
        AwsSsmDocumentTag.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AwsSsmDocumentTag>): AwsSsmDocumentTag {
        if (!model) return null;
        return AwsSsmDocumentTag.newInstance(<AwsSsmDocumentTag> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AwsSsmDocumentTag) {
        if (!obj) return;

        models.AwsSsmDocumentTag.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AwsSsmDocumentTag): boolean {
        Object.setPrototypeOf(obj, AwsSsmDocumentTag.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Name for the tag key
     */
    key: string;

    /**
     * Value for the respective tag key
     */
    value: string;

}
